import cn from 'clsx'
import * as React from 'react'
import InlineSVG from 'svg-inline-react'
import type { EmailCampaignTrack } from 'types/campaign'
import TrackArtwork from 'components/common/tracks/track-artwork'

/**
 * Track list artwork component that displays artwork or fallback icons
 * Shows track artwork if available, otherwise displays type-specific SVG icons
 * @param type - Type of action: 'streams' or 'downloads' for fallback icon selection
 * @param track - Email campaign track object containing artwork data
 */
const TrackListArtwork = ({
  type,
  track,
}: {
  type: 'streams' | 'downloads'
  track: EmailCampaignTrack
}): React.ReactElement<'div'> => {
  const className = cn('tracks-list__row__icon', {
    [`tracks-list__row__icon--${type}`]: !track.artwork,
  })
  return (
    <div className={className}>
      {track.artwork && (
        <TrackArtwork
          track={
            {
              artwork: track.artwork,
            } as any
          }
        />
      )}
      {!track.artwork && type === 'streams' && (
        <InlineSVG src={require('!svg-inline!./streams.svg')} />
      )}
      {!track.artwork && type === 'downloads' && (
        <InlineSVG src={require('!svg-inline!./downloads.svg')} />
      )}
    </div>
  )
}

export default TrackListArtwork
